import { CashboxOperations } from '@/types';

export const CASHBOX_OPERATIONS = [
  { label: 'Приход', value: CashboxOperations.INCOME },
  { label: 'Расход', value: CashboxOperations.OUTCOME },
];
